module.exports = __webpack_public_path__ + "static/media/sell_start_service_rent_2.22261a72.jpg";